// Professional.jsx
import React from "react";

const experiences = [
  {
    role: "Summer Associate",
    org: "Boston Consulting Group",
    location: "Chicago, IL",
    time: "Summer 2025",
    bullets: [
      "Engineered assortment optimizer for Fortune 500 client, lifting dead-net profit by 5%",
      "Developed Databricks reporting to compare markets and quantify gains.",
      "Translated merchandising goals into platform rules and feature specs."
    ]
  },
  {
    role: "Software Engineering Intern",
    org: "Electric Power Research Institute",
    location: "Charlotte, NC",
    time: "Summer 2024",
    bullets: [
      "Built frontend in Python to visualize PV plant performance metrics.",
      "Implemented modular comparisons across geospatial and time series data.",
      "Optimized API backend with caching and anonymization, reducing server load by 15%."
    ]
  },
  {
    role: "Product Management Intern",
    org: "Goodnotes",
    location: "Hong Kong SAR",
    time: "Summer 2023",
    bullets: [
      "Redesigned shop UI and ranking algorithm, driving $500k+ in monthly sales.",
      "Launched 5 external partnerships, boosting inventory by 25%.",
      "Revamped pricing via elasticity tests, increasing revenue by 20%."
    ]
  },
  {
    role: "Project Lead",
    org: "Team Flow (Michigan Health Engineered for All Lives)",
    location: "Ann Arbor, MI / Kumasi, Ghana",
    time: "Sept 2023 – Present",
    bullets: [
      "Built IV drip rate monitor using an STM32 MCU with 80% cost savings.",
      "Led user research in Kumasi, Ghana, interviewing 20+ healthcare staff.",
      "Secured $35K+ in grant funding through technical and equity-focused proposal."
    ]
  }
];

const Professional = () => {
  return (
    <section id="experience-professional">
      <h2 className="text-4xl font-header font-bold text-primary mb-8 underline text-center">
        Professional Experience
      </h2>
      <p className="text-lg font-body text-neutral-dark text-center mb-12 max-w-3xl mx-auto">
        Continuously seeking impact drive opportunities at the intersection of engineering and strategy. My work spans consulting, software, product, and global health innovation.
      </p>

      <div className="relative border-l-2 border-neutral-dark/10 pl-6 space-y-16">
        {experiences.map((exp, index) => (
          <div key={index} className="relative pl-6">
            <div className="absolute -left-3 top-2 w-6 h-6 bg-primary border-2 border-white rounded-full shadow"></div>
            <div className="bg-background p-6 rounded-xl shadow border border-neutral-dark/10 w-full md:w-3/4">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <h3 className="text-xl font-semibold text-primary">{exp.role}</h3>
                  <p className="text-neutral-dark">{exp.org} — <span className="italic">{exp.location}</span></p>
                </div>
                <p className="text-sm text-neutral-medium whitespace-nowrap">{exp.time}</p>
              </div>
              <ul className="list-disc list-inside space-y-2 text-neutral-dark">
                {exp.bullets.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Professional;
